export var ETransferFundsSortColumns;
(function (ETransferFundsSortColumns) {
    ETransferFundsSortColumns["NAME"] = "Name";
    ETransferFundsSortColumns["YEAR_1"] = "Year1";
    ETransferFundsSortColumns["YEAR_3"] = "Year3";
    ETransferFundsSortColumns["YEAR_5"] = "Year5";
    ETransferFundsSortColumns["FUND_SIZE"] = "FundSize";
    ETransferFundsSortColumns["EXP_RATIO"] = "ExpenseRatio";
    ETransferFundsSortColumns["RATING"] = "Rating";
})(ETransferFundsSortColumns || (ETransferFundsSortColumns = {}));
export var ETransferFundsSortOrder;
(function (ETransferFundsSortOrder) {
    ETransferFundsSortOrder["ASCENDING"] = "ASC";
    ETransferFundsSortOrder["DESCENDING"] = "DESC";
})(ETransferFundsSortOrder || (ETransferFundsSortOrder = {}));
